import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import { get } from 'lodash';

export const getAssessmentLabels = (subject, assessmentLabelIds = []) => {
  const {
    subjectLabels = {},
    actions: { deleteLabel, updateLabelAssociations },
  } = useTeacherOrganizeContext({ masterSubject: subject.id });

  const assessmentLabels = assessmentLabelIds.map((labelId) =>
    get(subjectLabels, `labels[${labelId}]`),
  );

  return { deleteLabel, assessmentLabels, updateLabelAssociations };
};
